export const CAB_UI_EVENT_NAME = {
  NAV_OPEN: 'cabNavOpen'
};

export const CAB_UI_EVENT = {
  NAV_OPEN: new Event(CAB_UI_EVENT_NAME.NAV_OPEN)
};